import { Component, OnInit, ChangeDetectorRef, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { WellsService } from '../_services/wells.service';
import { ComponentRefService } from '../_services/componentRef.service';
import { Location } from '@angular/common';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { SharedFunctionsService } from '../_services/sharedFunctions.service';
import { state } from '../_services/sharedFunctions.service';
import { UserProfileService } from '../../_services/user-profile.service';
import { UserProfile } from '../../_models/user-profile';
import { Well } from '../_models/well';
declare let $: any;

@Component({
  selector: 'addwell',
  templateUrl: './addwell.component.html',
  styleUrls: ['./addwell.component.css']
})

export class AddWellComponent implements OnInit {
  wells: any;
  fields: any = "";
  company: string = "";
  search: string = "";
  wellClone: any;
  hasChanges: boolean = false;
  newWell: Well = new Well();
  message: string = "";
  addWellAlertClass: string = 'alert';
  wellStatus: Array<any> = [];
  fieldBatteries: Array<any> = [];
  fieldGasFacilities: Array<any> = [];
  gasOutPlateSize: Array<any> = [];
  gasInPlateSize: Array<any> = [];
  landPropertyID: Array<any> = [];
  landLeases: Array<any> = [];
  landUnits: Array<any> = [];
  wellLandWaterTypeID: Array<any> = [];
  wellSingleDualTypeID: Array<any> = [];
  injectionMethodID: Array<any> = [];
  skimTanks: Array<any> = [];
  regWellTypeID: Array<any> = [];
  regWellStatus: Array<any> = [];
  swdID: Array<any> = [];
  cloningWell: boolean = false;
  wellToClone: any;
  wellInfoAlertClass: string = "";
  wellPlateInfo: Array<any> = [];
  wellInfoMessage: string = "";
  submitted: boolean = false;
  alertSuccess: string = "alert alert-success";
  alertDanger: string = "alert alert-danger";
  readonly todaysDate: Date = new Date();
  wellBatteries: any;
  wellGasFacilities: any;
  disableList: Array<string> = [];
  lookUpValueGroups: Array<string> = [];
  toggleCtrl: toggleControl = <toggleControl>{};
  config: any;
  dropdownOptions: SelectItem[] = [];
  addWellFrm: UntypedFormGroup;
  selectedWellDate: Date = new Date();
  invalidNumMessage: string = "Please make sure to enter a valid whole number or leave the input empty.";
  invalidFloatMessage: string = "Please make sure to enter a valid decimal number or leave the input empty.";
  invalidPercentageMessage: string = "Please make sure to enter a valid decimal number between 0 and 1 or leave the input empty.";
  invalidAPIMessage: string = "";
  dateSelectOptions: any = {
    minDate: null,
    maxDate: null
  };
  p: number = 1;
  requiredNotLoaded: boolean = false;
  cloneSelection: SelectItem;
  mode: state = state.createMode;
  editModeWellReset: any = null;
  datesForDropDown: Array<any> = []
  datesForDropDownRaw: Array<any> = []
  entryID: number = 0;
  editWellID: number = 0;
  timelineSelected: any;
  multiTimelineEntries: boolean = false;
  atLeastOneDirty: boolean = false;
  past30Days: boolean = false;
  orginialStartDate: any = "N/A";
  up: UserProfile;
  wellNameValid: boolean = false;
  fieldDateRangeEndString: string = "n/a";
  fieldDateRangeStartString: string = "n/a";
  loadingWells: boolean = false;

  constructor(private ref: ChangeDetectorRef,
    private router: Router, public ele: ElementRef, private WellsService: WellsService, public location: Location,
    private fb: UntypedFormBuilder, private CompRefService: ComponentRefService, private SharedFunctions: SharedFunctionsService,
    private ups: UserProfileService) {

    this.CompRefService.addwell = this;
    this.ups.userProfile$.subscribe(result => {
      this.up = result
    })
    this.addWellFrm = this.fb.group({
      'EffectiveDate': [null, Validators.compose([Validators.required])],
      'CloneWellID': null,
      'hydrate': false,
      'wellName': [null, Validators.compose([Validators.required, this.validWellName.bind(this)])],// nedded to add the bind(this) to the end of this validation to enable to 'this' to work in function
      'statusID': [null, Validators.compose([Validators.required])],
      'batteryID': null,
      'isGasLiftWell': false,
      'injectionWell': false,
      'gasFacilityID': null,
      'fieldID': [null, Validators.compose([Validators.required])],
      'apiNumber': [null, Validators.compose([this.SharedFunctions.validAPIstring.bind(this)])],
      'directionalFlag': null,
      'reservoirName': null,
      'totalVerticalDepth': [null, Validators.compose([this.validFloatInput])],
      'measuredDepth': [null, Validators.compose([this.validFloatInput])],
      'subSeaDepth': [null, Validators.compose([this.validFloatInput])],
      'referenceElevation': [null, Validators.compose([this.validFloatInput])],
      'plugBackDepth': [null, Validators.compose([this.validFloatInput])],
      'packerDepth': [null, Validators.compose([this.validIntInputs])],
      'mmbtUperMCF': [null, Validators.compose([this.validFloatInput])],
      'gasOutMeterDiameter': null,
      'gasOutPlateSize': null,
      "gasOutPlateCoefficient": null,
      'gasOutSpringSize': [null, Validators.compose([this.validFloatInput])],
      'gasInMeterDiameter': null,
      'gasInPlateSize': null,
      "gasInPlateCoefficient": null,
      'gasInSpringSize': [null, Validators.compose([this.validFloatInput])],
      'nrioil': [null, Validators.compose([this.validPercentage])],
      'nrigas': [null, Validators.compose([this.validPercentage])],
      'nwioil': [null, Validators.compose([this.validPercentage])],
      'nwigas': [null, Validators.compose([this.validPercentage])],
      'insuranceConverage': null,
      'landPropertyID': null,
      'landUnitFK': null,
      'landLeaseFK': null,
      'wellLandWaterTypeID': null,
      'wellSingleDualTypeID': null,
      'injectionMethodID': null,
      'skimTankID': null,
      'valve1PSC': [null, Validators.compose([this.validFloatInput])],
      'pumpbore': [null, Validators.compose([this.validFloatInput])],
      'lat': [null, Validators.compose([this.validPosNegFloatInput])],
      'lon': [null, Validators.compose([this.validPosNegFloatInput])],
      'xcoord': [null, Validators.compose([this.validPosNegFloatInput])],
      'ycoord': [null, Validators.compose([this.validPosNegFloatInput])],
      'masip': [null, Validators.compose([this.validFloatInput])],
      'notes': "",
      'regFieldName': null,
      'regFieldCode': null,
      'regLeaseName': null,
      'leaseNumber': null,
      'serialNumber': null,
      'regWellNumber': null,
      'regDrillPermit': null,
      'regCommPermit': null,
      'regWellStatus': null,
      'regWellTypeID': null,
      'operatorName': null,
      'regOperCode': null,
      'regState': null,
      'regCounty': null,
      'regParishCode': null,
      'regDistrict': null,
      'regSection': null,
      'regTownship': null,
      'regRange': null,
      'regPool': null,
      'regClass': null,
      'regSubClass': null,
      'regMeridian': null,
      'regFacilityCode': null,
      'regTransporterCode': null,
      'swdid': null,
      'swdMaxPSI': [null, Validators.compose([this.validFloatInput])],
      'swdMaxRate': [null, Validators.compose([this.validFloatInput])],
      'swdIntervalTop': [null, Validators.compose([this.validFloatInput])],
      'swdIntervalBottom': [null, Validators.compose([this.validFloatInput])],
      'perfSetID': null,
      'gasInisPercentageChart': null,
      'gasInisSquareRootChart': null,
      'gasOutisPercentageChart': null,
      'gasOutisSquareRootChart': null,
      'isGasCalculated': null,
      'isGasAllocatedDaily': null,
      'isOilAllocatedDaily': null,
      'isWaterAllocatedDaily': null,
      'cF_DailyProdSP': null,
      'hasFluidMeter': null,
      'isUnitized': null,
      'isIntermittentWell': null,
      'sortOrder': null,
      'isOperated': true
    });
  }

  ngOnInit() {
    if (typeof window != 'undefined') {
      this.disableList = ["gasFacilityID",
        "mmbtUperMCF",
        "gasOutMeterDiameter",
        "gasOutPlateSize",
        "gasOutPlateCoefficient",
        "gasOutSpringSize",
        "gasInMeterDiameter",
        "gasInPlateSize",
        "gasInPlateCoefficient",
        "gasInSpringSize",
        "nrioil",
        "nrigas",
        "nwioil",
        "nwigas",
        "swdID"]
      this.lookUpValueGroups = ["RegulatoryWellType",
        "WellLandWaterType",
        "WellSingleDualType",
        "InjectionMethods"];
      this.toggleCtrl = {
        basicCollapsedBool: false,
        regCollapsedBool: false,
        gasCollapsedBool: false,
        swdCollapsedBool: false,
        completionCollapsedBoo: false,
        interestsCollapsedBool: false,
        landCollapsedBool: false,
        miscCollapsedBool: false,
        cloneCollapsedBool: false
      };
      this.config = {
        displayKey: "description", //if objects array passed which key to be displayed defaults to description
        search: true,//true/false for the search functionlity defaults to false,       
        searchPlaceholder: 'Search for wels to clone'
      }

      this.wells = null;
      this.company = this.up.currentCompany
     
      let modeSet: any = localStorage.getItem("wellMode");
      localStorage.removeItem("wellMode");
      if (null == modeSet) {modeSet = "createMode"}

      if (null !== modeSet && typeof modeSet !== "undefined") {
        this.mode = <state>modeSet
        if (this.mode.toString() == "editMode") {
          this.editModeInit()
        }
      }

      this.WellsService.getWellsInCompany(this.company).subscribe(result => {
        if (result !== "loading") {
          this.wells = result;
          this.wells.forEach((well: any) => {
            if (null != well.startDate) {
              well.startDate = new Date(well.startDate);
            }
          });
          this.loadingWells = false
          this.coventCloneWellsList();
        }
        else {
          this.loadingWells = true
          this.wells = [];
        }


      },
        error => {
          console.log(error);
          this.loadingWells = false;
          this.wells = [];
        });
     
      this.toggleLoader("statLoader", false);
      let ws = localStorage.getItem('wellstatus');
      if (null != ws) {
        this.wellStatus = JSON.parse(ws)

        this.toggleLoader("statLoader", true);
      } else {
        this.toggleLoader("statLoader", false);
        this.WellsService.getWellsStatuses(this.company)
          .subscribe(result => {
            this.wellStatus = <Array<any>>result;
            this.toggleLoader("statLoader", true);
          },
            error => {
              this.setErrorMessage("An error has occurred while trying to load 1 or more required dropdowns.");
              this.requiredNotLoaded = true;
              this.toggleLoader("statLoader", true);
            });
      }

      this.WellsService.getPlateInfo(this.company)
        .subscribe(result => {
          this.wellPlateInfo = result;
        },
          error => {
            console.log(error);
          })

      this.toggleLoader("fieldLoader", false);
      this.WellsService.getFieldsInCompany(this.company)
        .subscribe(result => {
          this.fields = result;
          this.toggleLoader("fieldLoader", true);
        },
          error => {
            this.setErrorMessage("An error has occurred while trying to load 1 or more required dropdowns.");
            this.requiredNotLoaded = true;
            this.toggleLoader("fieldLoader", true);
            console.log(error);
          })

      this.WellsService.getLandUnit(this.company).
        subscribe(result => {
          this.landUnits = result;
        },
          error => {
            console.log(error);
          });


      this.lookUpValueGroups.forEach(group => {
        this.WellsService.getLookUpValues(this.company, group)
          .subscribe(result => {
            this.setLookUpValueArray(group, result);
          }, error => {
            console.log(error);
          })
      });
      this.invalidAPIMessage = this.SharedFunctions.apiValidStringAlert;
    }
  }



  editModeInit() {
    let wellSet: any = JSON.parse(localStorage.getItem("wellid"));
    if (null != wellSet && typeof wellSet != "undefined") {
      this.editWellID = wellSet;
      this.WellsService.getTimelineDatesForDropdown(wellSet, this.company)
        .subscribe(
          result => {
            this.datesForDropDown = this.mapTimelineDropdown(result);
            this.datesForDropDownRaw = result;
            this.addWellFrm.markAsPristine();
            if (this.datesForDropDown.length > 1) { this.multiTimelineEntries = true; }
            if (this.datesForDropDown.length >= 3) {
              this.entryID = this.datesForDropDown[this.datesForDropDown.length - 2].value
            } else {
              this.entryID = this.datesForDropDown[this.datesForDropDown.length - 1].value
            }

            this.timelineDatesSelected(this.entryID);
            this.disableControls();
          },
          error => {
            console.log("Unable to get the timeline list for this well.")
          })
    }
  }

  mapTimelineDropdown(array: Array<any>) {
    let tempArray: Array<any> = []
    let tempitem: any = {};
    let sd: any;
    let ed: any;
    array.forEach(item => {
      tempitem = {};

      if (null != item.startDate ? sd = new Date(item.startDate).toDateString() : sd = "N/A")
        if (null != item.endDate ? ed = new Date(item.endDate).toDateString() : ed = "N/A")
          tempitem.label = sd + " to " + ed
      tempitem.value = item.entryID;
      tempArray.push(tempitem);
    })

    return tempArray;
  }

  statusChanged() {
    this.addWellFrm.controls['hydrate'].patchValue(false);
  }

  setFormDisabled() {

  }

  timelineDatesSelected(id: any) {
    let i = this.datesForDropDownRaw.findIndex(item => String(item.entryID) == String(id) ? true : false)
    let monthago: Date = new Date(new Date().setDate(new Date().getDate() - 30));
    let monthagoStr: string = monthago.getFullYear() + "-" + (monthago.getMonth() + 1) + "-" + monthago.getDate();
    let startDate: string = ""
    startDate = this.datesForDropDownRaw[i].startDate;
    if (null == startDate) { this.orginialStartDate = "N/A" }
    else {
      startDate = this.datesForDropDownRaw[this.datesForDropDownRaw.length - 1].startDate
      startDate = startDate.substring(0, startDate.indexOf("T"))
      let orgDateArray: Array<string> = startDate.split("-")
      this.orginialStartDate =  orgDateArray[1] + " / " + orgDateArray[2] + " / " +orgDateArray[0] ;
    }
    let plusOneStartDate = new Date(this.datesForDropDownRaw[i].startDate)
    plusOneStartDate.setDate(plusOneStartDate.getDate() + 1)

    if (null != this.datesForDropDownRaw[this.datesForDropDownRaw.length - 1].startDate && monthago.getTime() > new Date(this.datesForDropDownRaw[this.datesForDropDownRaw.length - 1].startDate).getTime()) {
      this.past30Days = true;
      this.addWellFrm.disable();
    }
    else {
      this.past30Days = false;
    }

    if (null == this.datesForDropDownRaw[i].startDate
      || monthago.getTime() > new Date(this.datesForDropDownRaw[i].startDate).getTime() ||
      this.datesForDropDownRaw.length == 1 && null == this.datesForDropDownRaw[i].startDate && null == this.datesForDropDownRaw[i].endDate ||
      this.datesForDropDownRaw.length <= 2) {
      this.setDateLimits(monthagoStr.toString(), this.datesForDropDownRaw[i].endDate);
    }
    else {
      this.setDateLimits(this.datesForDropDownRaw[i].startDate, this.datesForDropDownRaw[i].endDate);
    }
    this.getEditTimelineWell(this.editWellID);
  }

  setDateLimits(startDate: string, endDate: any) {
    this.dateSelectOptions.minDate = null;
    this.dateSelectOptions.maxDate = null;
    this.dateSelectOptions.maxDate = new Date(this.todaysDate.toDateString());

    if (null != startDate) {
      let untilDate: Date = new Date(startDate);
      untilDate.setDate(untilDate.getDate() + 1);
      this.dateSelectOptions.minDate = untilDate;
    }
  }

  onCalendarOpen() {
    if (this.addWellFrm.controls["EffectiveDate"].value == null) {
      this.addWellFrm.controls["EffectiveDate"].patchValue(new Date(this.todaysDate.toDateString()));
    }
  } 

  getCopyOfOptions(): any {
    return JSON.parse(JSON.stringify(this.dateSelectOptions));
  }

  hasChanged() {
    this.hasChanges = true;

  }

  checkIfInputsAreDirty() {
    if (this.compareDirtyControls()) {
      this.atLeastOneDirty = true
    }
    else {
      this.atLeastOneDirty = false
    }
  }

  copyWellSelected(id: any) {


    if (null != id) {
      this.addWellFrm.controls['CloneWellID'].patchValue(id);
      this.WellsService.getWellCloneInfo(this.company, this.addWellFrm.controls['CloneWellID'].value)
        .subscribe(result => {

          this.wellClone = result;
          this.search = String(id);
          this.cloningWell = true;
          this.addWellFrm.controls['fieldID'].patchValue(this.wellClone.fieldID);
          this.fieldChanged(false);
          this.setForm();
          if (this.mode.toString() == "createMode" || this.mode == 1) {
            this.hasChanges = true;
          }

        }, error => {
          console.log(error);
        });
    }
    else {
      this.addWellFrm.controls['CloneWellID'].patchValue(id);
      this.search = "";
      this.resetForm();

    }
  }

  onDateChanged(event: any) {
    if (this.checkEffectiveDate30Days()) { this.addWellFrm.controls['hydrate'].patchValue(false) }
    if (this.checkMode("editMode")) {
      this.getFieldDatasheetDateRange(this.editWellID)
    }
    else if (this.checkMode("cloneMode")) {
      this.getFieldDatasheetDateRange(this.wellClone.id);
    }
    else {
      this.getFieldDatasheetDateRange(0);
    }
    
  }

  getEditTimelineWell(id: any) {
    if (null != id) {

      this.WellsService.getTimelineEntry(id, this.company, this.todaysDate)
        .subscribe(
          result => {
            this.wellClone = result;
            this.cloningWell = true;
            this.addWellFrm.controls['fieldID'].patchValue(this.wellClone.fieldID);
            this.fieldChanged(false);
            this.setForm();
            if (this.mode.toString() == "createMode" || this.mode == 1) {
              this.hasChanges = true;
            }
          },
          error => {
            console.log(error);
          })
    }
  }

  fieldChanged(nulls: boolean) {

    if (nulls) {
      this.nullDropDowns();
    }
    this.addWellFrm.controls['wellName'].updateValueAndValidity();
    this.getBatteriesInField();
    this.getGasFacilitiesInField();
    this.getSkimTanks();
    this.getLandLeases();
    this.getSWDInFields();
    this.getLandPropertiesID();
  }

  getBatteriesInField() {
    this.toggleLoader("battLoader", false);
    if (null == this.addWellFrm.controls['fieldID'].value) {
      this.fieldBatteries = [];
      this.toggleLoader("battLoader", true);
    } else {
    this.WellsService.getBatteriesInField(this.company, this.addWellFrm.controls['fieldID'].value)
      .subscribe(result => {
        this.fieldBatteries = result
        this.toggleLoader("battLoader", true);
      }, error => {
        console.log(error);
        this.toggleLoader("battLoader", true);
      })
  }
  }

  getGasFacilitiesInField() {
    this.toggleLoader("gasLoader", false);
    if (null == this.addWellFrm.controls['fieldID'].value) {
      this.fieldGasFacilities = [];
      this.toggleLoader("gasLoader", true);
    } else {
      this.WellsService.getGasFacilitiesInField(this.company, this.addWellFrm.controls['fieldID'].value)
        .subscribe(result => {
          this.fieldGasFacilities = result;
          this.toggleLoader("gasLoader", true);
        },
          error => {
            console.log(error);
            this.toggleLoader("gasLoader", true);
          })
    }
  }

  getSkimTanks() {

    this.toggleLoader("skimTankLoader", false);
    if (null == this.addWellFrm.controls['fieldID'].value) {
      this.skimTanks = [];
      this.toggleLoader("skimTankLoader", true);
    } else {
      this.WellsService.getTanks(this.company, this.addWellFrm.controls['fieldID'].value, this.addWellFrm.controls['batteryID'].value, true)
        .subscribe(result => {
          this.skimTanks = result;
          this.toggleLoader("skimTankLoader", true);
        },
          error => {
            console.log(error);
            this.toggleLoader("skimTankLoader", true);
          })
    }
  }

  getLandLeases() {
    if (null == this.addWellFrm.controls['fieldID'].value) {
      this.landLeases = [];
      
    } else {
      this.WellsService.getLandLease(this.company, this.addWellFrm.controls['fieldID'].value)
        .subscribe(result => {
          this.landLeases = result;

        },
          error => {
            console.log(error);
          });
    }
  }

  getSWDInFields() {
    if (null == this.addWellFrm.controls['fieldID'].value) {
      this.swdID = [];
    } else {
      this.WellsService.getSWDInField(this.company, this.addWellFrm.controls['fieldID'].value)
        .subscribe(result => {
          this.swdID = result;
        },
          error => {
            console.log(error);
          });
    }
  }

  getLandPropertiesID() {
    if (null == this.addWellFrm.controls['fieldID'].value) {
      this.landPropertyID = [];
    } else {
      this.WellsService.getLandPropertiesID(this.company, this.addWellFrm.controls['fieldID'].value)
        .subscribe(result => {
          this.landPropertyID = result;
        }, error => {
          console.log(error);
        })
    }
  }

  nullDropDowns() {
    this.fieldBatteries = [];
    this.swdID = [];
    this.fieldGasFacilities = [];
    this.landPropertyID = [];
    this.skimTanks = [];
    this.landLeases = [];
    this.addWellFrm.patchValue({
      'batteryID': null,
      'gasFacilityID': null,
      'skimTankID': null,
      'landLeaseFK': null,
      'swdid': null,
      'landPropertyID': null
    });
  }

  setLookUpValueArray(group: string, result: any) {
    switch (group) {
      case "WellLandWaterType":
        this.wellLandWaterTypeID = result;
        break;
      case "RegulatoryWellType":
        this.regWellTypeID = result;
        break;
      case "WellSingleDualType":
        this.wellSingleDualTypeID = result;
        break;
      case "InjectionMethods":
        this.injectionMethodID = result;
        break;
    }
  }


  injectionWellChange() {
    if (!this.past30Days) {
      if (this.addWellFrm.controls['injectionWell'].value == true) {
        this.addWellFrm.controls['swdid'].disable()
        this.addWellFrm.controls['nrioil'].disable()
        this.addWellFrm.controls['nrigas'].disable()
        this.addWellFrm.controls['nwioil'].disable()
        this.addWellFrm.controls['nwigas'].disable()
        this.addWellFrm.controls['gasFacilityID'].disable()
        this.addWellFrm.controls['mmbtUperMCF'].disable()

        this.addWellFrm.controls['gasOutMeterDiameter'].disable()
        this.addWellFrm.controls['gasOutPlateSize'].disable()

        this.addWellFrm.controls['gasOutSpringSize'].disable()
        this.addWellFrm.controls['gasInMeterDiameter'].disable()
        this.addWellFrm.controls['gasInPlateSize'].disable()

        this.addWellFrm.controls['gasInSpringSize'].disable()
      }
      if (this.addWellFrm.controls['injectionWell'].value == false) {
        this.addWellFrm.controls['swdid'].enable()
        this.addWellFrm.controls['nrioil'].enable()
        this.addWellFrm.controls['nrigas'].enable()
        this.addWellFrm.controls['nwioil'].enable()
        this.addWellFrm.controls['nwigas'].enable()
        this.addWellFrm.controls['gasFacilityID'].enable()
        this.addWellFrm.controls['mmbtUperMCF'].enable()

        this.addWellFrm.controls['gasOutMeterDiameter'].enable()
        this.addWellFrm.controls['gasOutPlateSize'].enable()

        this.addWellFrm.controls['gasOutSpringSize'].enable()
        this.addWellFrm.controls['gasInMeterDiameter'].enable()
        this.addWellFrm.controls['gasInPlateSize'].enable()

        this.addWellFrm.controls['gasInSpringSize'].enable()
      }
    } else {

    }
  }

  createWell() {
    this.submitted = true;
    let well = this.prepareWell();

    if (this.checkMode("createMode")) {
      if (this.addWellFrm.controls['injectionWell'].value) {
        well = this.nullifyInputs(well);
      }
      let hydrateCommand: boolean = false;
      if (this.checkEffectiveDate30Days()) { hydrateCommand = this.addWellFrm.controls['hydrate'].value }
      this.WellsService.createWell(this.company, well, this.addWellFrm.controls['EffectiveDate'].value, hydrateCommand)
        .subscribe(result => {
          this.addWellAlertClass = "alert alert-success";
          this.message = result;
          this.submitted = false;
          this.hasChanges = false;
          alert("Created well " + this.addWellFrm.controls['wellName'].value + " in field " + this.returnFieldName() + '.');
          this.exitPage();
        },
          error => {


            this.setErrorMessage(error.toString());
            console.log(error);
            this.submitted = false;
          })
    }
    if (this.checkMode("editMode")) {
      let hydrateCommand: boolean = false;
      well.fieldID = this.wellClone.fieldID;
      well.wellName = this.wellClone.wellName;
      well = this.getDisabledControlsValues(well);
      well.wellID = this.editWellID;

      if (well.gasOutMeterDiameter === Math.round(this.wellClone.gasOutMeterDiameter)) {
        well.gasOutMeterDiameter = this.wellClone.gasOutMeterDiameter
      }

      let eID: number = this.datesForDropDownRaw[this.datesForDropDownRaw.length - 1].entryID
      if (this.checkEffectiveDate30Days()) { hydrateCommand = this.addWellFrm.controls['hydrate'].value }
      this.WellsService.editTimeLineEntry(this.company, well, this.addWellFrm.controls['EffectiveDate'].value, eID, hydrateCommand, this.editWellID)
        .subscribe(result => {
          this.addWellAlertClass = "alert alert-success";
          this.message = result;
          this.submitted = false;
          this.hasChanges = false;
          alert("Edited well " + this.addWellFrm.controls['wellName'].value + " in field " + this.returnFieldName() + '.');
          this.exitPage();
        },
          error => {
            this.setErrorMessage(error.toString());
            console.log(error.toString());
            this.submitted = false;
          })
    }
  }

  setErrorMessage(error: string) {
    this.addWellAlertClass = "alert alert-danger";
    this.message = error;
  }

  nullifyInputs(well: any) {
    this.disableList.forEach(input => {
      well[input] = null;
    });
    return well;
  }

  returnFieldName() {
    let name = "";
    this.fields.forEach((field: any) => {
      if (field.fieldID == this.addWellFrm.controls['fieldID'].value) {
        name = field.fieldName;
      }
    });

    return name;
  }

  coventCloneWellsList() {
    let list: SelectItem[] = [];
    let option: SelectItem;
    this.wells.forEach((item: any) => {
      option = <SelectItem>{ label: item.wellName + " | " + item.wellID, value: item.wellID };


      list.push(option);
    });
    this.dropdownOptions = list;
  }

  checkDate() {
    let check: boolean = false;
    let date = this.addWellFrm.controls['EffectiveDate'].value;
    let testdate = this.todaysDate.getTime() > date.getTime();
    if (this.todaysDate.toDateString() === date.toDateString() || this.todaysDate.getTime() > date.getTime()) {
      check = true;
    }
    return check;
  }

  prepareWell() {

    let obj: any = Object.assign(this.newWell, this.addWellFrm.value)
    Object.keys(obj).forEach((key: any) => {
      if (null != obj[key]) {
        let testkey = obj[key].toString().trim();
        if (undefined == obj[key] || testkey.length == 0 && key != "EffectiveDate" && key != "CloneWellID" && key != "hydrate") {
          obj[key] = null;
        }
        if (key == "isGasLiftWell") {
          if (obj[key] == true) {
            obj[key] = 1;
          }
          else if (obj[key] == false) {
            obj[key] = 0;
          }
        }
      }

    })

    return obj;
  }

  toggleArrows(collaspeCheck: string) {

    if (this.toggleCtrl[collaspeCheck]) {
      this.toggleCtrl[collaspeCheck] = false
    } else {
      this.toggleCtrl[collaspeCheck] = true
    }
  }

  toggleDiv(divID: string, collaspeCheck: string) {
    if (this.toggleCtrl[collaspeCheck]) {
      ($("#" + divID) as any).collapse('hide');
    } else {
      ($("#" + divID) as any).collapse('show');
    }

    this.toggleArrows(collaspeCheck);
  }

  toggleLoader(id: string, hide: boolean) {
    let ele = document.getElementById(id);
    if (null != ele) {
      ele.hidden = hide;
    }
  }

  toggleInputDisableFromList() {
    this.disableList.forEach(control => {
      if (this.addWellFrm.controls['injectionWell'].value) {
        this.addWellFrm.controls[control].disable();
      } else {
        this.addWellFrm.controls[control].enable();
      }
    })
  }

  collaspeAll() {
    ($(".collapse") as any).collapse('hide');
    this.toggleCtrl.basicCollapsedBool = false;
    this.toggleCtrl.completionCollapsedBoo = false;
    this.toggleCtrl.gasCollapsedBool = false;
    this.toggleCtrl.interestsCollapsedBool = false;
    this.toggleCtrl.landCollapsedBool = false;
    this.toggleCtrl.miscCollapsedBool = false;
    this.toggleCtrl.regCollapsedBool = false;
    this.toggleCtrl.swdCollapsedBool = false;
    this.toggleCtrl.cloneCollapsedBool = false;

  }

  countProperties(obj: any) {
    return Object.keys(obj).length;
  }

  setForm() {
    this.addWellFrm.patchValue({
      'CloneWellID': this.wellClone.wellID,
      'fieldID': this.wellClone.fieldID,
      'wellName': this.wellClone.wellName,
      'statusID': this.wellClone.statusID,
      'batteryID': this.wellClone.batteryID,
      'isGasLiftWell': this.wellClone.isGasLiftWell,
      'injectionWell': this.wellClone.injectionWell,
      'gasFacilityID': this.wellClone.gasFacilityID,
      'apiNumber': this.wellClone.apiNumber != null ? this.wellClone.apiNumber.toString().trim() : null,
      'directionalFlag': this.wellClone.directionalFlag,
      'reservoirName': this.wellClone.reservoirName,
      'totalVerticalDepth': this.wellClone.totalVerticalDepth,
      'measuredDepth': this.wellClone.measuredDepth,
      'subSeaDepth': this.wellClone.subSeaDepth,
      'referenceElevation': this.wellClone.referenceElevation,
      'plugBackDepth': this.wellClone.plugBackDepth,
      'packerDepth': this.wellClone.packerDepth,
      'mmbtUperMCF': this.wellClone.mmbtUperMCF,
      'gasOutMeterDiameter': null != this.wellClone.gasOutMeterDiameter?Math.round(this.wellClone.gasOutMeterDiameter):null,
      'gasOutPlateSize': this.wellClone.gasOutPlateSize,
      "gasOutPlateCoefficient": this.wellClone.gasOutPlateCoefficient,
      'gasOutSpringSize': this.wellClone.gasOutSpringSize,
      'gasInMeterDiameter': this.wellClone.gasInMeterDiameter,
      'gasInPlateSize': this.wellClone.gasInPlateSize,
      "gasInPlateCoefficient": this.wellClone.gasInPlateCoefficient,
      'gasInSpringSize': this.wellClone.gasInSpringSize,
      'nrioil': this.wellClone.nrioil,
      'nrigas': this.wellClone.nrigas,
      'nwioil': this.wellClone.nwioil,
      'nwigas': this.wellClone.nwigas,
      'insuranceConverage': null,
      'landPropertyID': this.wellClone.landPropertyID,
      'landUnitFK': this.wellClone.landUnitFK,
      'landLeaseFK': this.wellClone.landLeaseFK,
      'wellLandWaterTypeID': this.wellClone.wellLandWaterTypeID,
      'wellSingleDualTypeID': this.wellClone.wellSingleDualTypeID,
      'injectionMethodID': this.wellClone.injectionMethodID,
      'skimTankID': this.wellClone.skimTankID,
      'valve1PSC': this.wellClone.valve1PSC,
      'pumpbore': this.wellClone.pumpbore,
      'lat': this.wellClone.lat,
      'lon': this.wellClone.lon,
      'xcoord': this.wellClone.xcoord,
      'ycoord': this.wellClone.ycoord,
      'masip': this.wellClone.masip,
      'notes': this.wellClone.notes,
      'regFieldName': this.wellClone.regFieldName,
      'regFieldCode': this.wellClone.regFieldCode,
      'regLeaseName': this.wellClone.regLeaseName,
      'leaseNumber': this.wellClone.leaseNumber,
      'serialNumber': this.wellClone.serialNumber,
      'regWellNumber': this.wellClone.regWellNumber,
      'regDrillPermit': this.wellClone.regDrillPermit,
      'regCommPermit': this.wellClone.regCommPermit,
      'regWellStatus': this.wellClone.regWellStatus,
      'regWellTypeID': this.wellClone.regWellTypeID,
      'operatorName': this.wellClone.operatorName,
      'regOperCode': this.wellClone.regOperCode,
      'regState': this.wellClone.regState,
      'regCounty': this.wellClone.regCounty,
      'regParishCode': this.wellClone.regParishCode,
      'regDistrict': this.wellClone.regDistrict,
      'regSection': this.wellClone.regSection,
      'regTownship': this.wellClone.regTownship,
      'regRange': this.wellClone.regRange,
      'regPool': this.wellClone.regPool,
      'regClass': this.wellClone.regClass,
      'regSubClass': this.wellClone.regSubClass,
      'regMeridian': this.wellClone.regMeridian,
      'regFacilityCode': this.wellClone.regFacilityCode,
      'regTransporterCode': this.wellClone.regTransporterCode,
      'swdid': this.wellClone.swdid,
      'swdMaxPSI': this.wellClone.swdMaxPSI,
      'swdMaxRate': this.wellClone.swdMaxRate,
      'swdIntervalTop': this.wellClone.swdIntervalTop,
      'swdIntervalBottom': this.wellClone.swdIntervalBottom,
      'perfSetID': this.wellClone.perfSetID,
      'gasInisPercentageChart': this.wellClone.gasInisPercentageChart,
      'gasInisSquareRootChart': this.wellClone.gasInisSquareRootChart,
      'gasOutisPercentageChart': this.wellClone.gasOutisPercentageChart,
      'gasOutisSquareRootChart': this.wellClone.gasOutisSquareRootChart,
      'isGasCalculated': this.wellClone.isGasCalculated,
      'isGasAllocatedDaily': this.wellClone.isGasAllocatedDaily,
      'isOilAllocatedDaily': this.wellClone.isOilAllocatedDaily,
      'isWaterAllocatedDaily': this.wellClone.isWaterAllocatedDaily,
      'cF_DailyProdSP': this.wellClone.cF_DailyProdSP,
      'hasFluidMeter': this.wellClone.hasFluidMeter,
      'isUnitized': this.wellClone.isUnitized,
      'isIntermittentWell': this.wellClone.isIntermittentWell,
      'sortOrder': this.wellClone.sortOrder,
      'isOperated': this.wellClone.isOperated

    });
    this.addWellFrm.markAsPristine();
    this.addWellFrm.controls['wellName'].markAsDirty();
    this.addWellFrm.controls['fieldID'].markAsDirty();
    this.addWellFrm.controls['statusID'].markAsDirty();
    this.addWellFrm.controls['batteryID'].markAsDirty();
    this.addWellFrm.controls['wellName'].updateValueAndValidity();
    this.setPlateDiameterDropDown(this.wellClone.gasOutMeterDiameter, false, true);
    this.setPlateSizeCoef(this.wellClone.gasOutMeterDiameter, this.wellClone.gasOutPlateSize, false);
    this.setPlateDiameterDropDown(this.wellClone.gasInMeterDiameter, true, true);
    this.setPlateSizeCoef(this.wellClone.gasInMeterDiameter, this.wellClone.gasInPlateSize, true);
    this.injectionWellChange();


  }

  getFieldDatasheetDateRange(id: number) {
    if (null != this.addWellFrm.controls['EffectiveDate'].value) {
      let date = this.addWellFrm.controls['EffectiveDate'].value;
      if (null != this.addWellFrm.controls['EffectiveDate'].value) {
        date = this.addWellFrm.controls['EffectiveDate'].value;
      }
      let fieldDate = this.WellsService.getFieldDatasheetDateRange(this.company, date, this.todaysDate, id)
        .subscribe(result => {
          if (null != result[0]) {
            let fieldDSStartDate = this.SharedFunctions.getDateForDateOffSet(result[0]);
            this.fieldDateRangeStartString = fieldDSStartDate.toDateString();
          } else {
            this.fieldDateRangeStartString = "n/a";
          }

          if (null != result[1]) {
            let fieldDSEndDate = this.SharedFunctions.getDateForDateOffSet(result[1]);
            this.fieldDateRangeEndString = fieldDSEndDate.toDateString();
          } else {
            this.fieldDateRangeEndString = "n/a";
          }
        },
          error => {
            console.log(error);
          });
    }
  }


  checkMode(mode: string) {
    if (this.mode.toString().toLowerCase() == mode.toLowerCase())
      return true
    else
      return false;
  }

  resetConfirm(dropdown: any) {
    if (confirm("You are about to reset the form, are you sure you want to continue?")) {
      if (this.checkMode("createMode") && null != dropdown) {
        dropdown.resetFilter();
      }

      this.cloneSelection = null;
      this.resetForm();
    }
  }

  resetForm() {
    if (this.mode.toString() == "createMode" || this.mode == 1) {
      this.addWellFrm.reset({
        'CloneWellID': null,
        'hydrate': false,
        'wellName': null,// nedded to add the bind(this) to the end of this validation to enable to 'this' to work in function
        'statusID': null,
        'batteryID': null,
        'isGasLiftWell': false,
        'injectionWell': false,
        'gasFacilityID': null,
        'fieldID': null,
        'apiNumber': null,
        'directionalFlag': null,
        'reservoirName': null,
        'totalVerticalDepth': null,
        'measuredDepth': null,
        'subSeaDepth': null,
        'referenceElevation': null,
        'plugBackDepth': null,
        'packerDepth': null,
        'mmbtUperMCF': null,
        'gasOutMeterDiameter': null,
        'gasOutPlateSize': null,
        'gasOutPlateCoefficient': null,
        'gasOutSpringSize': null,
        'gasInMeterDiameter': null,
        'gasInPlateSize': null,
        'gasInPlateCoefficient': null,
        'gasInSpringSize': null,
        'nrioil': null,
        'nrigas': null,
        'nwioil': null,
        'nwigas': null,
        'insuranceConverage': null,
        'landPropertyID': null,
        'landUnitFK': null,
        'landLeaseFK': null,
        'wellLandWaterTypeID': null,
        'wellSingleDualTypeID': null,
        'injectionMethodID': null,
        'skimTankID': null,
        'valve1PSC': null,
        'pumpbore': null,
        'lat': null,
        'lon': null,
        'xcoord': null,
        'ycoord': null,
        'masip': null,
        'notes': "",
        'regFieldName': null,
        'regFieldCode': null,
        'regLeaseName': null,
        'leaseNumber': null,
        'serialNumber': null,
        'regWellNumber': null,
        'regDrillPermit': null,
        'regCommPermit': null,
        'regWellStatus': null,
        'regWellTypeID': null,
        'operatorName': null,
        'regOperCode': null,
        'regState': null,
        'regCounty': null,
        'regParishCode': null,
        'regDistrict': null,
        'regSection': null,
        'regTownship': null,
        'regRange': null,
        'regPool': null,
        'regClass': null,
        'regSubClass': null,
        'regMeridian': null,
        'regFacilityCode': null,
        'regTransporterCode': null,
        'swdid': null,
        'swdMaxPSI': null,
        'swdMaxRate': null,
        'swdIntervalTop': null,
        'swdIntervalBottom': null,
        'perfSetID': null,
        'gasInisPercentageChart': null,
        'gasInisSquareRootChart': null,
        'gasOutisPercentageChart': null,
        'gasOutisSquareRootChart': null,
        'isGasCalculated': null,
        'isGasAllocatedDaily': null,
        'isOilAllocatedDaily': null,
        'isWaterAllocatedDaily': null,
        'cF_DailyProdSP': null,
        'hasFluidMeter': null,
        'isUnitized': null,
        'isIntermittentWell': null,
        'sortOrder': null,
        'isOperated': null
      });
      this.cloningWell = false;
      this.hasChanges = false;
      this.fieldBatteries = [];
      this.fieldGasFacilities = [];
      this.swdID = [];
    }
    else if (this.mode.toString() == "editMode" || this.mode == 0) {
      this.editModeInit()
      this.addWellFrm.reset();
    }
    this.injectionWellChange();
  }

  disableSubmit() {
    let check: boolean = false;
    if (!this.addWellFrm.controls['EffectiveDate'].valid) {
      check = true;
    }
    if (!this.addWellFrm.controls['wellName'].valid) {
      check = true;
    }
    if (!this.addWellFrm.controls['statusID'].valid) {
      check = true;
    }
    if (!this.addWellFrm.controls['fieldID'].valid) {
      check = true;
    }
    if (!this.addWellFrm.controls['batteryID'].valid || (null == this.addWellFrm.controls['batteryID'].value && this.addWellFrm.controls['statusID'].value != '4')) {
      check = true;
    }


    return check;
  }

  checkWellNameExist() {
    this.toggleLoader("wellNameLoader", false);
    let check: boolean = false;
    check = this.checkNameExistInField(this.addWellFrm.controls["wellName"].value);
    this.toggleLoader("wellNameLoader", true);
    return check;
  }

  validIntInputs(control: any) {
    if (control.value) {
      if ((control.value % 1) == 0 || null == control.value) {
        let controlValue: string = String(control.value)
        const match = controlValue.match('^(-+)?[0-9][0-9]*$');
        if (match) {
          let isNegative = match[0].startsWith('-')
          if (!isNegative) return null;
          return { 'invalidString': true }
        }
        else {
          return { 'invalidString': true }
        }
      }
      else {
        return { 'invalidString': true };
      }
    }
    else {
      return null;
    }
  }

  validNonNegIntInputs(control: any) {
    if (control.value) {

      if (((control.value % 1) == 0) && control.value >= 0 || null == control.value) {
        return null;
      }
      else {
        return { 'invalidNumber': true };
      }

    }
    else {
      return null;
    }
  }

  validFloatInput(control: any) {

    if (!!control.value) {

      let point: number = 0;
      let valid: boolean = true;
      let val: string = control.value;
      let controlChar: Array<any> = val.toString().split('');
      controlChar.forEach(char => {
        if (char == '.') {
          point = point + 1;
        }
        else {
          if (char >= '0' && char <= '9') {
          } else {
            valid = false
          }
        }
      });
      if (valid && point <= 1) {
        return null;
      }
      else {
        return { 'invalidString': true };
      }
    }
    else {

      return null;
    }

  }

  validPosNegFloatInput(control: any) {

    if (control.value) {


      let point: number = 0;
      let valid: boolean = true;
      let val: string = control.value;
      let controlChar: Array<any> = val.toString().split("");
      controlChar.forEach((char, index) => {
        if (char == '.') {
          point = point + 1;
        }
        else if (char == '-') {
          if (index != 0) {

            valid = false
          }
        }
        else {

          if (char >= '0' && char <= '9') {
          } else {
            valid = false
          }
        }
      });
      if (valid && point <= 1) {
        return null;
      }
      else {
        return { 'invalidString': true };
      }
    }
    else {

      return null;
    }

  }

  validWellName(control: any) {

    if (control.value && this.checkMode("createMode")) {
      this.toggleLoader("wellNameLoader", false);
      if (this.checkWellNameExist()) {
        this.toggleLoader("wellNameLoader", true);
        return { 'invalidNumber': true };
      }
      this.toggleLoader("wellNameLoader", true);
      return null;
    }
    else {
      this.toggleLoader("wellNameLoader", true);
      return null;
    }
  }

  validPlateSize() {
    if ((null != this.addWellFrm.controls['gasOutMeterDiameter'].value && null == this.addWellFrm.controls['gasOutPlateSize'].value && !this.addWellFrm.controls['injectionWell'].value) ||
      (null != this.addWellFrm.controls['gasInMeterDiameter'].value && null == this.addWellFrm.controls['gasInPlateSize'].value) && !this.addWellFrm.controls['injectionWell'].value) {
      return true;
    }
    return false;
  }

  validPercentage(control: any) {
    if (control.value) {
      if ((!Number.isNaN(control.value) && control.value >= 0 && control.value <= 1) && control.value.toString().trim() != "" || null == control.value) {
        return null;
      }
      else {
        return { 'invalidString': true };
      }

    }
    else {
      return null;
    }
  }

  hideChangedIndicator(control: string) {
    let check: boolean = false;
    try {

      if (this.checkMode("createMode")) {
        if (!this.cloningWell) {
          if (control != 'isOperated') {
            if (null != this.addWellFrm.controls[control].value && "" != this.addWellFrm.controls[control].value) {
              check = true;
            }
          } else {
            check = !this.addWellFrm.controls['isOperated'].value
          }
        }
        else {
          if (this.addWellFrm.controls[control].value != this.wellClone[control]) {
            check = true;
          }
        }
      }
      else {
        let originalValue = this.wellClone[control] == null ? "" : this.wellClone[control];
        let changedValue = this.addWellFrm.controls[control].value == null ? "" : this.addWellFrm.controls[control].value        
        if (changedValue != originalValue) {
          check = true;
        }
        if (control == "gasOutMeterDiameter" && changedValue == Math.round(originalValue)) {
          check = false;
        }
      }
    }
    catch (err) {
    }
    if (this.checkMode("editMode")) {
      this.checkIfInputsAreDirty();
    }

    return check;

  }

  setPlateDiameterDropDown(plateDiameter: number | null, gasIn: boolean, wellCloned: boolean) {
    let id: string = "gasOutPlateLoader";
    try {
      if (gasIn) { id = "gasInPlateLoader"; }
      this.toggleLoader(id, false);
      if (null == plateDiameter) {
        if (gasIn) {
          this.gasInPlateSize = <any>[];
          this.addWellFrm.patchValue({ 'gasInPlateCoefficient': null, 'gasInPlateSize': null });
        }
        else {
          this.gasOutPlateSize = <any>[];
          this.addWellFrm.patchValue({ 'gasOutPlateCoefficient': null, 'gasOutPlateSize': null });
        }
      }
      else {
        let plate = this.wellPlateInfo.find(i => i.plateDiameter === Math.round(plateDiameter));
        if (gasIn) {
          if (typeof plate != "undefined") {
            this.gasInPlateSize = plate.plateSizeCoef;
            if (!wellCloned) {
              this.addWellFrm.patchValue({ 'gasInPlateCoefficient': null, 'gasInPlateSize': null });
            }
            else {
              this.addWellFrm.patchValue({ 'gasInPlateCoefficient': null });
            }
          }
        }
        else {
          if (typeof plate != "undefined") {
            this.gasOutPlateSize = plate.plateSizeCoef;
            if (!wellCloned) {
              this.addWellFrm.patchValue({ 'gasOutPlateCoefficient': null, 'gasOutPlateSize': null });
            }
            else {
              this.addWellFrm.patchValue({ 'gasOutPlateCoefficient': null });
            }
          }
        }
      }
      this.toggleLoader(id, true);
    } catch (err) {
      console.log(err);
      this.toggleLoader(id, true);
    }
  }

  setPlateSizeCoef(plateDiameter: number | null, plateSize: number | null, gasIn: boolean) {
    let id: string = "gasOutPlateCoefLoader";
    try {
      if (gasIn) { id = "gasInPlateCoefLoader"; }
      this.toggleLoader(id, false);
      if (null == plateSize) {
        if (gasIn) {
          this.addWellFrm.patchValue({ 'gasInPlateCoefficient': null });
        } else {
          this.addWellFrm.patchValue({ 'gasOutPlateCoefficient': null });
        }
      }
      else {
        let plate = this.wellPlateInfo.find(i => i.plateDiameter === Math.round(plateDiameter));
        if (typeof plate != "undefined") {
          let plateSizes = plate.plateSizeCoef.find((p: any) => p.plateSize === plateSize);
          if (typeof plateSizes != "undefined") {
            if (gasIn) {
              this.addWellFrm.patchValue({ 'gasInPlateCoefficient': plateSizes['plateCoef'] });
            } else {
              this.addWellFrm.patchValue({ 'gasOutPlateCoefficient': plateSizes['plateCoef'] });
            }
          }
        }
      }

      this.toggleLoader(id, true);
    }
    catch (err) {
      console.log(err);
      this.toggleLoader(id, true);
    }
  }

  isFormInvalid() {
    if (this.checkMode("createMode")) {

      if (!this.addWellFrm.controls['EffectiveDate'].valid || null == this.addWellFrm.controls['EffectiveDate'].value) {

        return true;
      }
      else if (null == !this.addWellFrm.controls['fieldID'].value || !this.addWellFrm.controls['fieldID'].dirty || !this.addWellFrm.controls['fieldID'].valid) {

        return true;
      }
      else if (!this.cloningWell && (!this.addWellFrm.controls['wellName'].dirty || !this.addWellFrm.controls['wellName'].valid || null == this.addWellFrm.controls['wellName'].value)) {

        return true;
      }
      else if (this.cloningWell && (!this.addWellFrm.controls['wellName'].dirty || !this.addWellFrm.controls['wellName'].valid || null == this.addWellFrm.controls['wellName'].value || this.checkNameExistInField(this.addWellFrm.controls['wellName'].value))) {

        return true
      }
      else if (!this.addWellFrm.controls['statusID'].dirty || !this.addWellFrm.controls['statusID'].valid || null == this.addWellFrm.controls['statusID'].value) {

        return true;
      }
      else if ((this.addWellFrm.controls['statusID'].value != '6' && (null == this.addWellFrm.controls['batteryID'].value || 0 == this.addWellFrm.controls['batteryID'].value)) || !this.addWellFrm.controls['batteryID'].valid) {

        return true;
      }
      else if (this.addWellFrm.controls['apiNumber'].invalid) {
        return true;
      }

      return false;
    }
    else {
      if (!this.addWellFrm.controls['EffectiveDate'].valid || null == this.addWellFrm.controls['EffectiveDate'].value) {

        return true;
      }
      else if (!this.addWellFrm.controls['statusID'].valid || null == this.addWellFrm.controls['statusID'].value) {
        return true;
      }
      else if ((this.addWellFrm.controls['statusID'].value != '6' && null == this.addWellFrm.controls['batteryID'].value) || !this.addWellFrm.controls['batteryID'].valid) {
        return true;
      }
      return false;

    }

  }

  findInvalidControls() {
    let invalid = [];
    let controls = this.addWellFrm.controls;
    for (let name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }

  }

  getDisabledControlsValues(well: Array<any>) {
    let controls = this.addWellFrm.controls;
    for (let name in controls) {
      if (controls[name].disabled) {
        well[name] = this.wellClone[name];
      }
    }
    if (controls["injectionWell"].value) well["swdid"] = null;
    return well;
  }

  compareDirtyControls() {
    let check: boolean = false
    let controls = this.addWellFrm.controls;
    for (let name in controls) {

      if (controls[name].dirty) {
        if (name != "EffectiveDate") {
          let originalValue = this.wellClone[name] == null ? "" : this.wellClone[name];
          if (originalValue != controls[name].value) {
            check = true;
          }
        }
      }
    }
    return check;
  }

  exitPageConfirm() {
    let leave: boolean = false
    if (this.addWellFrm.dirty) {
      if (confirm("You are about to leave the page without add the well. Are you sure you want to do this? ")) {

        leave = true;
      }
    }
    else {
      leave = true;

    }
    return leave;
  }

  exitPage() {
    this.router.navigate(['/app/ControlPanel/wells']);
  }

  checkEffectiveDate30Days() {
    if (null != this.addWellFrm.controls['EffectiveDate'].value) {
      let monthAgo: Date = new Date(new Date().setDate(new Date().getDate() - 30));
      let date = this.addWellFrm.controls['EffectiveDate'].value;


      if (monthAgo.getTime() < date.getTime()) {
        return true;
      }
      return false
    }
    return false
  }

  disableControls() {
    if (this.checkMode("editMode")) {
      this.addWellFrm.controls["wellName"].disable();
      this.addWellFrm.controls["fieldID"].disable();
      if (this.multiTimelineEntries) {

        this.addWellFrm.controls["injectionWell"].disable();
        this.addWellFrm.controls["directionalFlag"].disable();
        this.addWellFrm.controls["lat"].disable();
        this.addWellFrm.controls["lon"].disable();
        this.addWellFrm.controls["xcoord"].disable();
        this.addWellFrm.controls["ycoord"].disable();
        this.addWellFrm.controls["regTownship"].disable();
        this.addWellFrm.controls["regSection"].disable();
        this.addWellFrm.controls["regParishCode"].disable();
        this.addWellFrm.controls["regDistrict"].disable();
        this.addWellFrm.controls["regCounty"].disable();
        this.addWellFrm.controls["regWellTypeID"].disable();
      }


    }

  }

  disableSWDEntry(id, name) {
    if (this.checkMode('editMode')) {
      if (id == this.wellClone.wellID && name == this.wellClone.wellName) {
        return true;
      }
      return false;
    }
    return false;
  }

  checkNameExistInField(wellName: string) {
    let wellsNamesCheck: Array<any> = this.wells.filter(w => w.wellName == wellName)
    let check: boolean = false;
    if (wellsNamesCheck.length == 0) {
      check =  false;
    }
    else {
      wellsNamesCheck.forEach((well) => {
        if (well.fieldID == this.addWellFrm.controls['fieldID'].value) {
          check = true;
        }
      })
      
    }
      return check; 
    
  }

}

interface toggleControl {
  [key: string]: boolean;
  basicCollapsedBool: boolean;
  regCollapsedBool: boolean;
  gasCollapsedBool: boolean;
  swdCollapsedBool: boolean
  completionCollapsedBoo: boolean;
  interestsCollapsedBool: boolean;
  landCollapsedBool: boolean;
  miscCollapsedBool: boolean;
  cloneCollapsedBool: boolean;
}
